import Flickity from "flickity";
require("flickity-as-nav-for");

const mainSlider = document.querySelector("[data-branch-slider]");
const asNavSliders = document.querySelector("[data-branch-slider-nav]");

if (mainSlider) {
	new Flickity(mainSlider, {
		// options
		contain: true,
		pageDots: false,
		prevNextButtons: false,
	});
}
if (asNavSliders) {
	new Flickity(asNavSliders, {
		// options
		asNavFor: mainSlider,
		contain: true,
		pageDots: false,
		prevNextButtons: false,
		draggable: ">4",
	});
}
